import { Link } from "react-router-dom"
import PendingApplications from "../../components/AssociationAdmin/Applications/PendingApplications"
import TreatedApplications from "../../components/AssociationAdmin/Applications/TreatedApplications"
import { useState } from "react"

export default function AssociationAdminApplicationsPage() {
    const [mode, setMode] = useState('pending')

    const changeTab = (mode) => {
        setMode(mode)
    }
    return (
        <>
            {/* <!-- start page title --> */}
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0">Applications</h4>

                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><Link to="/app">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Applications</li>
                            </ol>
                        </div>

                    </div>
                </div>
            </div>
            {/* <!-- end page title --> */}

            <div className="row" id="contactList">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header d-flex align-items-center border-0">
                            <ul className="nav nav-tabs-custom rounded card-header-tabs border-bottom-0" role="tablist">
                                <li className="nav-item" onClick={() => changeTab('pending')}>
                                    <a className="nav-link active" data-bs-toggle="tab" href="#pendingApplication" role="tab">
                                        <i className="fas fa-home"></i> Open Applications
                                    </a>
                                </li>
                                <li className="nav-item" onClick={() => changeTab('closed')}>
                                    <a className="nav-link" data-bs-toggle="tab" href="#treatedApplication" role="tab">
                                        <i className="far fa-user"></i> Closed Applications
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="card-body border border-dashed border-end-0 border-start-0">
                            <div className="tab-content">
                                <div className="tab-pane active" id="pendingApplication" role="tabpanel">
                                    <PendingApplications name={mode}/>
                                </div>
                                {/* <!--end tab-pane--> */}
                                <div className="tab-pane" id="treatedApplication" role="tabpanel">
                                    <TreatedApplications name={mode}/>
                                </div>
                                {/* <!--end tab-pane--> */}
                            </div>
                        </div>
                    </div>
                    {/* <!--end card--> */}
                </div>
                {/* <!--end col--> */}
            </div>
            {/* <!--end row--> */}
        </>
    )
}